import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AdminShell.css';

const COLLAPSED_KEY = 'owAdminSidebarCollapsed';

const Icon = ({ children }) => (
  <svg className="admin-icon" viewBox="0 0 24 24" width="20" height="20" fill="none"
    stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

const NAV_ITEMS = [
  {
    to: '/admin/restaurants/active',
    label: 'Active restaurants',
    icon: <Icon><circle cx="12" cy="12" r="9" /><path d="m8 12.5 2.8 2.8L16 9.8" /></Icon>,
  },
  {
    to: '/admin/restaurants/inactive',
    label: 'Inactive restaurants',
    icon: <Icon><circle cx="12" cy="12" r="9" /><path d="M9 9l6 6M15 9l-6 6" /></Icon>,
  },
  {
    to: '/admin/users',
    label: 'Users',
    icon: <Icon><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6M16 4.8a3.5 3.5 0 0 1 0 6.4M18 14.3c2.2.7 3.5 2.6 3.5 5.7" /></Icon>,
  },
];

const AdminShell = () => {
  const { email, logout } = useAuth();
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(COLLAPSED_KEY) === 'true');

  const toggle = () => {
    setCollapsed((prev) => {
      localStorage.setItem(COLLAPSED_KEY, String(!prev));
      return !prev;
    });
  };

  return (
    <div className={`admin-shell${collapsed ? ' is-collapsed' : ''}`}>
      <aside className="admin-sidebar">
        <div className="admin-sidebar-top">
          <span className="admin-brand">OW Admin</span>
          <button
            type="button"
            className="admin-icon-btn"
            onClick={toggle}
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            aria-expanded={!collapsed}
          >
            <Icon>
              <rect x="3" y="4" width="18" height="16" rx="2" />
              <path d="M9 4v16" />
              {collapsed ? <path d="m14 10 2 2-2 2" /> : <path d="m16 10-2 2 2 2" />}
            </Icon>
          </button>
        </div>

        <nav className="admin-nav" aria-label="Admin navigation">
          {NAV_ITEMS.map(({ to, label, icon }) => (
            <NavLink key={to} to={to} className="admin-nav-link" title={collapsed ? label : undefined}>
              {icon}
              <span className="admin-nav-label">{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar-bottom">
          {email && <span className="admin-user ph-no-capture" title={email}>{email}</span>}
          <button type="button" className="admin-nav-link admin-logout" onClick={logout}
            title={collapsed ? 'Log out' : undefined}>
            <Icon><path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 8l-4 4 4 4M6 12h10" /></Icon>
            <span className="admin-nav-label">Log out</span>
          </button>
        </div>
      </aside>

      <section className="admin-content">
        <Outlet />
      </section>
    </div>
  );
};

export default AdminShell;
